export default "__VITE_ASSET__D$XwmbC2__"